import { useState } from "react";
import styles from "./Section.module.css";
import Card from "../Card/Card";
import {Box, CircularProgress } from "@mui/material";
import Carousel from "../Carousel/Carousel";

const Section = ({ data, title, type }) => {
  const [carouselToggle, setCarouselToggle] = useState(true);

  const handleToggle = () => {
    setCarouselToggle(!carouselToggle);
  };
  return (
    <div>
      <div className={styles.header}>
        <h3>{title}</h3>
        <h4 className={styles.toggleText} onClick={handleToggle}>
          {carouselToggle ? "Show All" : "Collapse All"}
        </h4>
      </div>
      {(!data || data.length === 0) ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <div className={styles.cardWrapper}>
          {!carouselToggle ? (
            <div className={styles.wrapper}>
                {data.map((card) => (
                <Card data={card} type={type} key={card.id} />
                ))}
            </div>
          ) : (
            <Carousel 
            data={data} 
            renderCardComponent={(data) => (
                <Card data={data} type={type} key={data.id}/>
            )}/>
          )}
        </div>
      )}
    </div>
  );
};

export default Section;